import { SearchBar } from '@/components/Common';
import { Header } from '@/components/Layout/Header/Header';
import TopicsList from '@/components/Views/Topics/TopicsList';
import { EpreuveFilter } from './EpreuveFilter';
import { EpreuveForm } from './EpreuveForm';
import { EpreuveList } from './EpreuveList';
import { useDisciplineStore } from '@/store/DisciplineStore/DisciplineStore';
import { useEpreuve } from './Epreuve.hook';
const Epreuve = () => {
  const { setSelectedDiscipline, selectedDiscipline } =
    useDisciplineStore();
  const { disciplines } = useEpreuve();
  return (
    <div className="flex flex-col max-h-screen">
      <Header title="Epreuves du BAC" userName="Mas Aly" role="Admin" />
      <div className="grid grid-cols-[25%_auto] items-start">
        <div className="pt-5 flex flex-col gap-10 h-[calc(100vh_-_110px)] overflow-hidden">
          <SearchBar placeholder="Rechercher une matière" />
          <TopicsList
            showBtn={false}
            items={disciplines ?? []}
            onItemClick={(item) => setSelectedDiscipline(item)}
            selectedItemId={selectedDiscipline?._id}
          />
        </div>
        <div className="flex flex-col gap-2 pl-10 pr-4 pt-3 h-[calc(100vh_-_110px)] overflow-hidden">
          <EpreuveFilter />
          <EpreuveList />
          <EpreuveForm />
        </div>
      </div>
    </div>
  );
};

export default Epreuve;
